export default function serializeOrderedField(orderedField) {
  const value = orderedField.value;
  let valueObj = null;
  if (orderedField.product_order_field.type === "ProductOrderField::List") {
    valueObj = { value: value && value.id ? value.id : null };
  } else if (orderedField.product_order_field.type === "ProductOrderField::PickupPoint") {
    valueObj = value
      ? {
          pickup_point_option_id: value.pickup_point_option_id,
          custom_location_name: value.custom_location_name,
          custom_location_lat: value.custom_location_lat,
          custom_location_lng: value.custom_location_lng,
        }
      : null;
  } else {
    valueObj = { value };
  }
  return {
    id: orderedField.id,
    product_order_field_id: !orderedField.id ? orderedField.product_order_field.id : undefined,
    value: valueObj,
  };
}



// WEBPACK FOOTER //
// ./src/lib/utils/api/serializers/serializeOrderedField.js